import { Collapse, Grid } from '@mui/material';
import React from 'react';
import FormAutocomplete from '../../../../../shared/FormAutocomplete';
import FormSelect from '../../../../../shared/FormSelect';
import CustomInputLabel from '../../../../../../layout/styledcomponents/CustomInputLabel';

export default function WorkspaceType({
    experienceDetails,
    availability,
    control,
    spaceType,
    isMeetingRoom,
    setErrors,
}: any) {
    const totalDesks = experienceDetails?.details?.desks ?? 0;
    const totalPrivateOffices = experienceDetails?.details?.privateOffices ?? 0;
    const totalMeetingRooms = experienceDetails?.details?.meetingRooms ?? 0;

    const availDesks = availability?.desks ?? 0;
    const availPrivateOffices = availability?.privateOffices ?? 0;
    const availMeetingRooms = availability?.meetingRooms ?? 0;

    const commercialHasExistingBooking =
        availDesks < totalDesks ||
        availPrivateOffices < totalPrivateOffices ||
        availMeetingRooms < totalMeetingRooms;

    const isTypeUnavailable = (value: string) => {
        if (value === 'desk') return totalDesks > 0 && availDesks <= 0;
        if (value === 'privateOffice')
            return totalPrivateOffices > 0 && availPrivateOffices <= 0;
        if (value === 'meetingRoom')
            return totalMeetingRooms > 0 && availMeetingRooms <= 0;
        if (value === 'entireVenue') return commercialHasExistingBooking;
        return false;
    };

    const labelFor = (value: string) => {
        if (value === 'desk') return 'Dedicated Desks';
        if (value === 'privateOffice')
            return experienceDetails?.details?.subType === 'house'
                ? 'Rooms'
                : 'Private Offices';
        if (value === 'meetingRoom') return 'Meeting Rooms';
        if (value === 'entireVenue') return 'Entire Venue';
        return value;
    };

    const spacesFromConfig = Array.isArray(experienceDetails?.details?.spaces)
        ? experienceDetails.details.spaces.map((s: any) => ({
              value: s.value,
              label: s.label || labelFor(s.value),
              include:
                  s.value === 'desk'
                      ? totalDesks > 0
                      : s.value === 'privateOffice'
                        ? totalPrivateOffices > 0
                        : s.value === 'meetingRoom'
                          ? totalMeetingRooms > 0
                          : true,
          }))
        : [];

    const ensuredTypes = [
        ...(totalDesks > 0
            ? [{ value: 'desk', label: labelFor('desk'), include: true }]
            : []),
        ...(totalPrivateOffices > 0
            ? [
                  {
                      value: 'privateOffice',
                      label: labelFor('privateOffice'),
                      include: true,
                  },
              ]
            : []),
        ...(totalMeetingRooms > 0
            ? [
                  {
                      value: 'meetingRoom',
                      label: labelFor('meetingRoom'),
                      include: true,
                  },
              ]
            : []),
    ];

    const merged = [...spacesFromConfig, ...ensuredTypes].reduce(
        (acc: any[], cur: any) => {
            if (!acc.find((x) => x.value === cur.value)) acc.push(cur);
            return acc;
        },
        [],
    );

    const baseOptions = merged
        .filter((o) => o.include)
        .map((o) => ({
            value: o.value,
            label: `${o.label}${
                isTypeUnavailable(o.value) ? ' (unavailable)' : ''
            }`,
        }));

    const options = [
        ...baseOptions,
        {
            value: 'entireVenue',
            label: `Entire Venue${
                isTypeUnavailable('entireVenue') ? ' (unavailable)' : ''
            }`,
        },
    ];

    return (
        <>
            {experienceDetails.type === 'commercial' && (
                <>
                    <Grid pb='20px'>
                        <CustomInputLabel required={!spaceType}>
                            Workspace Type
                        </CustomInputLabel>
                        <FormAutocomplete
                            name='bookingInfo.spaceType'
                            control={control}
                            options={options}
                        />
                    </Grid>

                    <Collapse
                        in={
                            !!spaceType &&
                            spaceType !== 'meetingRoom' &&
                            spaceType !== 'entireVenue'
                        }
                    >
                        <Grid pb='20px'>
                            <CustomInputLabel>
                                Do you require a meeting room?
                            </CustomInputLabel>
                            <FormSelect
                                name='bookingInfo.reqMeetingRoom'
                                control={control}
                                defaultValue={false}
                                options={[
                                    { value: true, label: 'Yes' },
                                    { value: false, label: 'No' },
                                ]}
                            />
                        </Grid>
                    </Collapse>
                </>
            )}
        </>
    );
}
